// Builds a full URL for a user avatar served from the API host. The server
// stores avatars as paths like "/uploads/avatars/<file>"; we need to prepend
// the API origin (REACT_APP_API_URL with the trailing /api stripped) so the
// browser does not try to fetch it from the frontend host.
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5200/api';
const ORIGIN = API_BASE.replace(/\/api\/?$/, '');

export function avatarUrl(avatar) {
  if (!avatar) return null;
  if (/^https?:\/\//i.test(avatar)) return avatar;
  return `${ORIGIN}${avatar.startsWith('/') ? '' : '/'}${avatar}`;
}
